import React, { useContext } from "react"
import Header from "../../Header/Header"
import Footer from "../../Footer/Footer"
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Link } from 'react-router-dom';
import { AppRoutes } from "../../../config/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { langMap } from "./i18n";
import LanguageContext from "../../../utils/context/i18n/languageContext";



const TermsAndConditions = () => {

    const lang = useContext(LanguageContext).lang;


    return(

        <main className="main-tabledpage">
            <section className="section-header bg-primary-lc text-black-lc align-items-stretch border-header" id="header">
                <Header/>
            </section>
            <section className="row-tabledpage section-body">
                <div className="single-tabledpage pb-5 pt-5">
                    <p className="text-center">
                    <Card.Link as={Link} to={AppRoutes.Presentation.path} className="text-gray-lc-600">
                        <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> {langMap.BackButton[lang]}
                    </Card.Link>
                    </p>
                    <Col xs={6} className="body-termsandcond">
                        <h3 className="fw-bolder w-100 text-center title-termsandconditions text-secondary-lc py-2 mt-2">
                            {langMap.Title[lang]}
                        </h3>
                        <div className="m-6 mt-5 mb-4 content-termsandconditions">
                            <p className="text-center">
                                {langMap.Intro1[lang]}
                                <b>{langMap.Intro2[lang]}</b>
                                {langMap.Intro3[lang]}
                                <b>{langMap.Intro4[lang]}</b>
                                {langMap.Intro5[lang]}
                                <b>{langMap.Intro6[lang]}</b>
                                {langMap.Intro7[lang]}
                            </p>
                            <div className="main-point mt-5">
                                <div className="main-point-number"><b>1</b></div>
                                <h5 className="mb-0 text-center main-point-text">{langMap.LicenseTitle[lang]}</h5>
                            </div>
                            <div className="mt-3 sub-point">
                                <p className="m-2 mt-1 mb-5">
                                    {langMap.LicenseText[lang]}
                                </p>
                            </div>
                            <div className="main-point mt-3">
                                <div className="main-point-number"><b>2</b></div>
                                <h5 className="mb-0 text-center main-point-text">{langMap.AbleTitle1[lang]} <u>{langMap.AbleTitle2[lang]}</u> {langMap.AbleTitle3[lang]}</h5>
                            </div>
                            <div className="mt-4 sub-point">
                                <div className="sub-point-number"><b>2.1</b></div>
                                <p className="m-2 mt-1">
                                    {langMap.AbleTextSection1[lang]}
                                </p>
                            </div>
                            <div className="mt-2 sub-point">
                                <div className="sub-point-number"><b>2.2</b></div>
                                <p className="m-2 mt-1">
                                    {langMap.AbleTextSection2[lang]}
                                </p>
                            </div>
                            <div className="mt-2 sub-point">
                                <div className="sub-point-number"><b>2.3</b></div>
                                <p className="m-2 mt-1">
                                    {langMap.AbleTextSection3[lang]}
                                </p>
                                <p className="m-2 mt-5  mb-5">
                                    {langMap.AbleTextSection4_1[lang]}
                                    <b>{langMap.AbleTextSection4_2[lang]}</b>
                                    {langMap.AbleTextSection4_3[lang]}
                                </p>
                            </div>
                            <div className="main-point mt-3">
                                <div className="main-point-number"><b>3</b></div>
                                <h5 className="mb-0 text-center main-point-text">{langMap.UnableTitle1[lang]} <u>{langMap.UnableTitle2[lang]}</u> {langMap.UnableTitle3[lang]}</h5>
                            </div>
                            <div className="mt-4 sub-point">
                                <div className="sub-point-number"><b>3.1</b></div>
                                <p className="m-2 mt-1">
                                    {langMap.UnableSection1[lang]}
                                </p>
                            </div>
                            <div className="mt-4 sub-point">
                                <div className="sub-point-number"><b>3.2</b></div>
                                <p className="m-2 mt-1">
                                    {langMap.UnableSection2[lang]}
                                </p>
                                <p className="m-2 mt-5">
                                    {langMap.UnableSection3_1[lang]}
                                    <b>{langMap.UnableSection3_2[lang]}</b>
                                    {langMap.UnableSection3_3[lang]}
                                </p>
                            </div>
                        </div>
                    </Col>
                </div>
            </section>
            <Footer className="w-100" />
        </main>
    )
}

export default TermsAndConditions